export const SET_ERROR_PAGE = "SET_ERROR_PAGE" as const;
export interface SetErrorPageAction {
  type: typeof SET_ERROR_PAGE;
  error: boolean;
  status: number;
}
